import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import Common from "@/common";

export const cryptoGroupMixin = {
  data() {
    return {
      paymentId: "",
      querySecret: "",
    };
  },
  computed: {
    ...mapGetters([
      "getVersion",
      "getGlobalApiRequestPending",
      "getCryptoGroupActiveGateways",
      "getCallBackUrl",
    ]),
    trc20TetherActive() {
      return this.getCryptoGroupActiveGateways.includes("tether");
    },
    trc20TronActive() {
      return this.getCryptoGroupActiveGateways.includes("tron");
    },
    bep20TetherActive() {
      return this.getCryptoGroupActiveGateways.includes("tether-bep20");
    },
    erc20TetherActive() {
      return this.getCryptoGroupActiveGateways.includes("tether-erc20");
    },
    erc20VatanActive() {
      return this.getCryptoGroupActiveGateways.includes("vatan-erc20");
    },
    bitcoinActive() {
      return this.getCryptoGroupActiveGateways.includes("bitcoin");
    },
  },
  methods: {
    ...mapMutations(["setStepperPage", "setIsCompName"]),
    handlePageChange(page) {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;
      const routes = {
        "tether-bep20": this.bep20TetherActive ? "/tether-bep20" : null,
        "trc20-tether": this.trc20TetherActive ? "/tether" : null,
        "trc20-tron": this.trc20TronActive ? "/tron" : null,
        "tether-erc20": this.erc20TetherActive ? "/tether-erc20" : null,
        "vatan-erc20": this.erc20VatanActive ? "/vatan-erc20" : null,
        bitcoin: this.bitcoinActive ? "/bitcoin" : null,
      };

      const route = routes[page];
      if (route) {
        this.$router.push(`${route}?id=${queryId}&s=${querySecret}`);
      } else {
        this.showDisabled();
      }
    },
    showDisabled() {
      alertHelper.infoAlert(
        "",
        "در حال حاضر این روش پرداخت غیر فعال می باشد، از روشهای دیگری استفاده کنید"
      );
    },
    cancelPayment() {
      let paymentId = this.$route.query.id;
      const callBackUrl = this.getCallBackUrl;
      alertHelper.loadingAlert();
      if (callBackUrl) {
        window.location.href = Common.createCallback(callBackUrl, paymentId, 0);
      } else {
        this.$http.delete(`payments/${paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
            result.data.data.callback_url,
            paymentId,
            0
          );
        });
      }
    },
  },
  created() {
    const queryId = this.$route.query.id;
    const querySecret = this.$route.query.s;
    if (!this.getCryptoGroupActiveGateways) {
      this.$router.push(`${"/"}?id=${queryId}&s=${querySecret}`);
    }
    this.setIsCompName("cryptoGroup");
  },
};
